<template>
  <div id="app">
    <router-view ref="page" @share="showShare" />
  </div>
</template>

<script>
import Env from "@/utils/env";
import ShareManager from "@/utils/ShareManager";

export default {
  name: "App",
  data() {
    return {
      shareManager: null
    };
  },
  components: {},
  methods: {
    showShare() {
      if (this.shareManager && Env.isMgtvApp) {
        window.MgtvApi.showShare();
      }
    },
    onShowToast(msg) {
      const { page } = this.$refs;
      if (page && page.onShowToast) {
        page.onShowToast(msg);
      }
    }
  },
  mounted() {
    setTimeout(() => {
      if (Env.isMgtvApp) {
        window.MgtvApi.callhandler("setWebview", {
          bouncing: false,
          popGesture: false // 无侧滑返回功能
        });
      }
    });
    if (!this.shareManager) {
      this.shareManager = new ShareManager(this.bridge);
      this.shareManager.setShowToast(this.onShowToast);
      this.shareManager.setShare({
        url: `${location.origin}${location.pathname}`,
        // desc: "《朋友请听好》第二季广播小站故事招募啦",
        // title: "《朋友请听好》第二季故事招募",
        // img: "https://tb.mgtv.com/mgtv-creatives/friend_share-2.jpg"
        desc: '想听的、想说的、想看的都在这里',
        title: '《朋友请听好》第二季全民小站',
        img: "https://tb.mgtv.com/mgtv-creatives/friend_share-3.png"
      });
    }
  }
};
</script>

<style>
#app {
  min-height: 100vh;
  overflow-x: hidden;
  margin: 0 auto;
  max-width: 1000px;
  position: relative;
}
</style>
